module.exports = "<!DOCTYPE html>\n<html>\n  <head>\n    ...\n    <link rel=\"stylesheet\" href=\"path/to/great-component.css\"/>\n    ...\n  </head>\n  <body>\n    <script src=\"path/to/vue.js\"></script>\n    <script src=\"path/to/great-component.js\"></script>\n    <script src=\"path/to/app.js\"></script>\n  </body>\n</html>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src-docs/app/snippets/installation-include.html
 ** module id = 241
 ** module chunks = 2
 **/